export const palette = {
  1: {
    border: 'border-navy-40',
    borderColor: '#dce3e6',
    text: 'text-navy-70',
    textColor: '#6d778a',
    background: 'bg-navy-20',
    backgroundColor: '#f5f6f6',
  },
  2: {
    border: 'border-pink-30',
    borderColor: '#ffa4d1',
    text: 'text-pink-90',
    textColor: '#ae0057',
    background: 'bg-pink-0',
    backgroundColor: '#fceff7',
  },
  3: {
    border: 'border-orange-30',
    borderColor: '#ffd8af',
    text: 'text-orange-90',
    textColor: '#b55b00',
    background: 'bg-orange-0',
    backgroundColor: '#fef8f1',
  },
  4: {
    border: 'border-blue-30',
    borderColor: '#99f8fd',
    text: 'text-blue-90',
    textColor: '#008193',
    background: 'bg-blue-0',
    backgroundColor: '#ebfdfe',
  },
  5: {
    border: 'border-blue-50',
    borderColor: '#00DCE8',
    text: 'text-blue-90',
    textColor: '#008193',
    background: 'bg-blue-10',
    backgroundColor: '#dafdff',
  },
  6: {
    border: 'border-blue-70',
    borderColor: '#009fb5',
    text: 'text-blue-90',
    textColor: '#008193',
    background: 'bg-blue-30',
    backgroundColor: '#99f8fd',
  },
  7: {
    border: 'border-blue-80',
    borderColor: '#008ea2',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-blue-60',
    backgroundColor: '#30cad9',
  },
  8: {
    border: 'border-blue-90',
    borderColor: '#008193',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-blue-70',
    backgroundColor: '#009fb5',
  },
  9: {
    border: 'border-orange-50',
    borderColor: '#ffa84f',
    text: 'text-orange-90',
    textColor: '#b55b00',
    background: 'bg-orange-10',
    backgroundColor: '#fff2e4',
  },
  10: {
    border: 'border-orange-50',
    borderColor: '#ffa84f',
    text: 'text-orange-90',
    textColor: '#b55b00',
    background: 'bg-orange-30',
    backgroundColor: '#ffd8af',
  },
  11: {
    border: 'border-orange-80',
    borderColor: '#cc6700',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-orange-60',
    backgroundColor: '#ff9126',
  },
  12: {
    border: 'border-orange-90',
    borderColor: '#b55b00',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-orange-80',
    backgroundColor: '#cc6700',
  },
  13: {
    border: 'border-pink-30',
    borderColor: '#ffa4d1',
    text: 'text-pink-90',
    textColor: '#ae0057',
    background: 'bg-pink-10',
    backgroundColor: '#ffdfef',
  },
  14: {
    border: 'border-pink-80',
    borderColor: '#c80061',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-pink-60',
    backgroundColor: '#f9007b',
  },
  15: {
    border: 'border-pink-90',
    borderColor: '#ae0057',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-pink-80',
    backgroundColor: '#c80061',
  },
  16: {
    border: 'border-navy-60',
    borderColor: '#b5bac4',
    text: 'text-navy-90',
    textColor: '#04293e',
    background: 'bg-navy-40',
    backgroundColor: '#dce3e6',
  },
  17: {
    border: 'border-navy-90',
    borderColor: '#04293e',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-navy-70',
    backgroundColor: '#6d778a',
  },
  18: {
    border: 'border-navy-70',
    borderColor: '#6d778a',
    text: 'text-white',
    textColor: '#ffffff',
    background: 'bg-navy-90',
    backgroundColor: '#04293e',
  },
};
